import React from 'react'

import style from './style.css'

export default (props) => (
    <div
        className={`${style.background} ${props.shadow ? style['shadow'+props.shadow] : ''} ${props.className || ''}`}
        style={{
            backgroundImage: "url("+props.image+")",
            ...props.style
        }}
        >
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/CoverImage/index.js